<template>
<!-- 文献发布页 -->
  <div class="form-content-container">
    <Form class="form-container">
      <div class="form-item title-item">
        <div class="title">
          <Input
            v-model="formValidate.title"
            :autosize="true" 
            type="textarea"
            placeholder="请输入标题(5-50字)"
          />
        </div>
        <div class="number"><span :class="formValidate.title.length > 50 ? 'fontColor' : ''">{{ formValidate.title.length }}</span> / 50</div>
      </div>
      <FormAuther
        @autherInfo="handleAuther"
        @autherInfo1="handleAuther1"
        @autherInfo2="handleAuther2"
        :formValidate="formValidate"
      ></FormAuther>
      <div class="form-item">
        <Input
          placeholder="请输入关键词，多个关键词之间用英文逗号“,”隔开"
          v-model.trim="formValidate.keyword"
        />
        <span class="xing">*</span>
      </div>
      <div class="form-item">
        <Input
          type="textarea"
          :rows="4"
          placeholder="请输入摘要"
          v-model.trim="formValidate.artSummary"
        />
        <span class="xing">*</span>
      </div>
      <div class="form-item">
        <Input
          placeholder="请输入刊名"
          v-model.trim="formValidate.periodical"
        />
        <span class="xing">*</span>
      </div>
      <div class="form-item">
        <div class="year">
          <Input
            placeholder="请输入年份"
            maxlength="4"
            v-model.trim="formValidate.journalsYear"
          />
          <span class="xing">*</span>
        </div>
        <div class="center">
          <Input
            placeholder="请输入卷数"
            maxlength="4"
            v-model.trim="formValidate.journalsVolume"
          />
        </div>
        <div class="stage">
          <Input
            placeholder="请输入期数"
            maxlength="5"
            v-model.trim="formValidate.journalsTerm"
          />
          <span class="xing">*</span>
        </div>
      </div>
      <div class="form-item">
        <Input
          placeholder="请输入原发刊名"
          v-model.trim="formValidate.originalTitle"
        />
        <span class="xing">*</span>
      </div>
      <div class="form-item">
        <Input
          placeholder="请输入原发刊期"
          v-model.trim="formValidate.originalPeriod"
        />
        <span class="xing">*</span>
      </div>
      <CapitalModel @handleFund="handleFund"></CapitalModel>
      <div class="form-item">
        <Select
          v-model.trim="formValidate.subjectCode"
          style="width: 200px"
          placeholder="请选择学科"
        >
          <Option
            v-for="item in subjectList"
            :value="item.subjectName"
            :key="item.id"
            >{{ item.subjectName }}</Option
          >
        </Select>
      </div>
      <div class="form-item">
        <div class="upload">
          <label>附件</label>
          <FileUplode :fileName="formValidate.accessoryName" @isUpload="isUpload" @handlefileUpload="handlefileUpload"/>
        </div>
        <span class="xing">*</span>
      </div>
      <div class="form-item">
        <div class="checkbox">
          <label>发布栏目</label>
          <Tree
            :data="trees"
            show-checkbox
            @on-check-change="changeCheck"
          ></Tree>
        </div>
        <span class="xing">*</span>
      </div>
      <div class="submit-container">
        <!-- <Button>预览</Button> -->
        <Button v-throttleClick="2000" :disabled="isUploadState" @click="handleSave(formValidate)">保存</Button>
        <Button v-throttleClick="2000" :disabled="isUploadState" @click="handleSubmit(formValidate)">发布</Button>
      </div>
    </Form>
    <AuthenticationModel
      v-if="isFlag"
      @handleClose="isFlag = false"
    ></AuthenticationModel>
  </div>
</template>

<script>
import FormAuther from "../../components/FormAuther.vue";
import CapitalModel from "../../components/CapitalModel.vue";
import { mapState } from "vuex";
import AuthenticationModel from "../../components/AuthenticationModel.vue";
import FileUplode from "../../components/fileUplode.vue";
export default {
  components: {
    FormAuther,
    CapitalModel,
    AuthenticationModel,
    FileUplode
  },
  created() {
    // 认证
    if (this.userInfo.user.customerType === 1) {
      this.isFlag = true;
    }
    this.getSubjectList();
    this.getTreeList({
      type: 2,
    });
  },
  data() {
    return {
      isUploadState: false,
      isFlag: false,
      subjectList: [], // 学科
      tempArr: [],
      treeList: [], //发布栏目
      formValidate: {
        firstAuther: "",
        firstUnit: "",
        firstUnitId: "",
        communicationAuthor: "",
        communicationAuthorUnit: "",
        communicationAuthorUnitId: "",
        title: "",
        keyword: "",
        artSummary: "",
        periodical: "",
        journalsYear: "",
        journalsVolume: "",
        journalsTerm: "",
        originalTitle: "",
        originalPeriod: "",
        interest: [], // 栏目
        articleAuthorList: [], // 其他作者
        fundIds: [], // 资金项目
        filePath: "", // 文件路径
        accessoryName: "", // 文件名称
        subjectCode: "", //学科
      },
    };
  },
  computed: {
    ...mapState(["token", "userInfo"]),
    trees() {
      return this.treeList.map((item) => {
        return {
          title: item.columnName,
          expand: true,
          menuIds: item.id,
          children:
            item.list &&
            item.list.map((v) => {
              return {
                title: v.columnName,
                menuIds: item.id,
                id: v.id,
              };
            }),
        };
      });
    },
  },
  methods: {
    verification(formValidate) {
      if (formValidate.title.length < 5) {
        this.$Message.error("标题不能少于5个字");
        return false;
      }
      if (formValidate.title.length > 50) {
        this.$Message.error("标题限制50个字");
        return;
      }
      // 分隔
      if (/^,|[，。？！.?!]+|(,,)+|,$/.test(formValidate.keyword)) {
        this.$Message.error("多个关键词，只能以英文逗号分隔");
        return false;
      } else {
        let arr = formValidate.keyword.split(",");
        for (let i = 0; i < arr.length; i++) {
          if (arr[i] == "") {
            this.$Message.error("字符串中存在多余英文逗号");
            return false;
          }
        }
      }
      return true;
    },
    async handleSave(formValidate) {
      // 认证
      if (this.userInfo.user.customerType === 1) {
        this.isFlag = true;
        return;
      }
      if (this.isEmpty(formValidate)) {
        this.$Message.error("不能为空");
      } else {
        if (!this.verification(formValidate)) {
          return;
        }
        this.tempArr.forEach((e) => {
          if (e.children && e.children.length > 0) {
            return;
          }
          this.formValidate.interest.push({
            projectId: 1,
            channelId1: e.menuIds || null,
            channelId2: e.id || null,
          });
        });
        const { data } = await this.$apis.userServe.webSave({
          auditStatus: 1,
          articleType: 0,
          type: 3,
          title: formValidate.title,
          keyword: formValidate.keyword,
          artSummary: formValidate.artSummary,
          periodical: formValidate.periodical,
          journalsYear: formValidate.journalsYear,
          journalsVolume: formValidate.journalsVolume,
          journalsTerm: formValidate.journalsTerm,
          originalTitle: formValidate.originalTitle,
          originalPeriod: formValidate.originalPeriod,
          fundIds: formValidate.fundIds,
          filePath: formValidate.filePath, // 文件路径
          accessoryName: formValidate.accessoryName, // 文件名称
          articlePushList: formValidate.interest,
          subjectCode: formValidate.subjectCode,
        });
        if (data.resultCode !== '200') {
          this.$Message.error('保存失败,请重新输入并保存');
          return
        }
        this.$Message.success('保存成功');
        this.$router.push("/user"); //
        // this.clearField(); // 清空
      }
    },
    async handleSubmit(formValidate) {
      // 认证
      if (this.userInfo.user.customerType === 1) {
        this.isFlag = true;
        return;
      }
      if (this.isEmpty(formValidate)) {
        this.$Message.error("不能为空");
      } else {
        if (!this.verification(formValidate)) {
          return;
        }
        this.tempArr.forEach((e) => {
          if (e.children && e.children.length > 0) {
            return;
          }
          this.formValidate.interest.push({
            projectId: 1,
            channelId1: e.menuIds || null,
            channelId2: e.id || null,
          });
        });
        const {data} = await this.$apis.userServe.webSave({
          auditStatus: 0,
          articleType: 0,
          type: 3,
          title: formValidate.title,
          keyword: formValidate.keyword,
          artSummary: formValidate.artSummary,
          periodical: formValidate.periodical,
          journalsYear: formValidate.journalsYear,
          journalsVolume: formValidate.journalsVolume,
          journalsTerm: formValidate.journalsTerm,
          originalTitle: formValidate.originalTitle,
          originalPeriod: formValidate.originalPeriod,
          fundIds: formValidate.fundIds,
          filePath: formValidate.filePath, // 文件路径
          accessoryName: formValidate.accessoryName, // 文件名称
          articlePushList: formValidate.interest,
          subjectCode: formValidate.subjectCode,
        });
        if (data.resultCode !== '200') {
          this.$Message.error('发布失败,请重新输入并发布');
          return
        }
        this.$Message.success('发布成功');
        this.$router.push("/user"); //
        // this.clearField(); // 清空
      }
    },
    // 学科
    async getSubjectList() {
      const resp = await this.$apis.userServe.getSubjectList();
      this.subjectList = resp.subjectList;
    },
    isUpload(state) {
      this.isUploadState = state
    },
    handlefileUpload(url,name) {
      this.formValidate.filePath = url;
      this.formValidate.accessoryName = name;
    },
    // 资金项目
    handleFund(fund) {
      fund.forEach((item) => {
        this.formValidate.fundIds.push(item.id);
      });
    },
    handleAuther2(name, enName, unit, orgId, userId) {
      this.formValidate.communicationAuthor = name;
      this.formValidate.communicationAuthorUnit = unit;
      this.formValidate.communicationAuthorUnitId = orgId;
      this.formValidate.communicationAuthorId = userId;
    },
    handleAuther1(list) {
      this.formValidate.articleAuthorList = list;
    },
    handleAuther(name, enName, unit, orgId, userId) {
      this.formValidate.firstAuther = name;
      this.formValidate.firstUnit = unit;
      this.formValidate.firstUnitId = orgId;
      this.formValidate.firstAutherId = userId;
    },
    // 发布栏目
    async getTreeList(data) {
      const resp = await this.$apis.userServe.getTreeList(data);
      if (typeof resp.data === "string") {
        this.treeList = [];
      } else {
        this.treeList = resp.data;
      }
    },
    changeCheck(item) {
      this.tempArr = item;
    },
    clearField() {
      // 清空
      this.formValidate.firstAuther = "";
      this.formValidate.firstUnit = "";
      this.formValidate.firstUnitId = "";
      this.formValidate.communicationAuthor = "";
      this.formValidate.communicationAuthorUnit = "";
      this.formValidate.communicationAuthorUnitId = "";
      this.formValidate.title = "";
      this.formValidate.keyword = "";
      this.formValidate.artSummary = "";
      this.formValidate.periodical = "";
      this.formValidate.journalsYear = "";
      this.formValidate.journalsVolume = "";
      this.formValidate.journalsTerm = "";
      this.formValidate.originalTitle = "";
      this.formValidate.originalPeriod = "";
      this.formValidate.interest = []; // 栏目
      this.formValidate.articleAuthorList = []; // 其他作者
      this.formValidate.fundIds = []; // 资金项目
      this.formValidate.filePath = ""; // 文件路径
      this.formValidate.accessoryName = ""; // 文件名称
      this.formValidate.subjectCode = ""; // 文件名称
    },
    isEmpty(f) {
      return (
        f.firstAuther === "" ||
        f.firstUnit === "" ||
        f.keyword === "" ||
        f.artSummary === "" ||
        f.periodical === "" ||
        f.journalsYear === "" ||
        f.journalsTerm === "" ||
        f.originalTitle === "" ||
        f.originalPeriod === "" ||
        f.accessoryName === "" ||
        this.tempArr.length === 0
      );
    },
  },
};
</script>

<style lang="scss" scoped>

::v-deep .ivu-tree-title:hover {
  background-color: #fff;
}
::v-deep .ivu-tree-title-selected, .ivu-tree-title-selected:hover {
  background-color: #fff;
}
::v-deep .ivu-tree-children li {
  display: flex;
}
::v-deep .ivu-tree-children li .ivu-tree-arrow {
  display: none;
}
::v-deep .ivu-tree-children li .ivu-tree-children li {
  margin: 30px 40px 0 -60px;
}
::v-deep .ivu-tree-children li .ivu-tree-title {
  width: 100px;
}
::v-deep .ivu-radio-group {
  white-space: nowrap;
}
.form-content-container {
  overflow: hidden;
  width: 1200px;
  margin: 38px auto 100px;
  background-color: #fff;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);
}
.ivu-input-wrapper ::v-deep input {
  border: none;
  background-color: #fff;
  height: 38px;
}
.ivu-input-wrapper ::v-deep input::-webkit-input-placeholder,
.ivu-input-wrapper ::v-deep textarea::-webkit-input-placeholder {
  color: #999;
}
.ivu-upload ::v-deep .ivu-upload-drag {
  border: none;
  display: flex;
  align-items: center;
}
::v-deep .ivu-upload {
  height: 38px;
  display: flex;
  align-items: center;
}
.ivu-input-wrapper ::v-deep textarea {
  border: none;
}
.form-container {
  margin: 0 auto 100px;
  padding: 100px 100px 0;
  width: 1200px;
  min-height: 1228px;
  background-color: #fff;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);
  .form-item {
    width: 100%;
    min-height: 85px;
    padding: 25px 0;
    border-bottom: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #999;
    position: relative;
    &:not(:last-child) {
      border-bottom: 1px solid #dcdcdc;
    }
    .fontColor {
      color: red;
    }
    .title {
      flex: 1;
      height: 100%;
      margin-right: 10px;
      line-height: 38px;
      position: relative;
      .right {
        position: absolute;
        right: 0;
        top: 0;
      }
      ::v-deep .ivu-input-type-textarea {
        textarea {
          font-size: 36px;
          resize: none;
        }
      }
    }
    .xing {
      width: 30px;
      color: red;
      text-align: center;
    }
    .left,
    .right {
      display: flex;
      justify-content: space-around;
      align-items: center;
    }
    .left {
      border-right: 1px solid #dcdcdc;
      width: 355px;
    }
    .right {
      margin-left: 10px;
      width: 642px;
    }
    .year,
    .center,
    .stage {
      display: flex;
      align-items: center;
    }
    .year {
      width: 299px;
      border-right: 1px solid #dcdcdc;
    }
    .center {
      width: 323px;
      border-right: 1px solid #dcdcdc;
    }
    .stage {
      width: 374px;
    }
    .checkbox {
      width: 970px;
      display: flex;
      align-items: center;
      padding-left: 7px;
      label {
        margin-right: 20px;
      }
    }
    .upload {
      display: flex;
      flex: 1;
      padding-left: 7px;
      align-items: center;
      label {
        margin-right: 20px;
      }
    }
  }
  .title-item {
    align-items: end;
  }
}
.submit-container {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 80px;
  height: 70px;
  background-color: #fff;
  text-align: center;
  line-height: 70px;
  button {
    margin: 0 10px;
  }
}
</style>
